$(document).ready(function(){
    var request;

    $('.ometriaCustomerID').each(function(){
        var $this = $(this);
        $this.val(Math.floor((Math.random()*999999999)+1))
    })

    var signUpDate = new Date().toISOString().slice(0, 19)+'+00';
    var headerCustomerID;

    $('.newsletter-popup-phone').keyup(function () { 
        this.value = this.value.replace(/[^0-9\.]/g,'');
    });

    $(document).on('submit', '.ometria-api-form', function(e) {

        e.preventDefault(); // avoid to execute the actual submit of the form.
        
        var form = $(this);
        var url = form.attr('action');

        // Abort any pending request
        if (request) {
        request.abort();
        }

        // setup some local variables
        var $form = $(this);

        if (window.theme.isCustomer == '') {
            headerCustomerID = $form.find('input[name="customer_id"]').val();          
        } else {
            headerCustomerID = window.theme.isCustomer;
        }

        // Let's select and cache all the fields
        if ($form.hasClass('ometria-email-form')) {
        var $email = $form.find('input[name="email"]').val().toLowerCase(),
            $type = $form.find('input[name="type"]').val().toLowerCase(),
            $customerID = headerCustomerID,
            $list = $form.find('input[name="add_to_list"]').val().toLowerCase(); 

        var ometriaData = {
                "@add_to_lists": [
                    $list
                ],
                "@collection": "customers",
                "@force_optin": true,
                "marketing_optin": "EXPLICITLY_OPTEDIN",
                "email": $email,
                "id": $customerID,
                "timestamp_subscribed": ""+signUpDate+""
        };

        } else {
            
        var $email = $form.find('input[name="email"]').val().toLowerCase(),
            $type = $form.find('input[name="type"]').val().toLowerCase(),
            $customerID = headerCustomerID,
            $smsSegment = 88,
            $list = $form.find('select[name="add_to_list"], input[name="add_to_list"]').val().toLowerCase(),
            $countryCode = $form.find('.iti__selected-dial-code').text(),
            $enteredNumber = $form.find('#newsletterPhoneNumber').val().toLowerCase(),
            $combinedNumber = $countryCode + $enteredNumber,
            $phone_number = $combinedNumber.trim(),
            $sms_marketing = $form.find('input[name="sms_marketing"]');

        if ($sms_marketing.is(':checked')) {
            $sms_marketing = true 
        } else {
            $sms_marketing = false
        }

        if ($enteredNumber === '') {
            var ometriaData = {
                "@add_to_lists": [
                    $list
                ],
                "@collection": "customers",
                "@force_optin": true,
                "marketing_optin": "EXPLICITLY_OPTEDIN",
                "email": $email,
                "id": $customerID,
                "timestamp_subscribed": ""+signUpDate+""
            };
        } else {
            var ometriaData = {
                "@add_to_lists": [
                    $list,
                    $smsSegment
                ],
                "@type": "contact",
                "channels": {
                    "sms": {
                        "allow_marketing": $sms_marketing,
                        "allow_transactional": true,
                        "dt_updated_marketing": ""+signUpDate+"",
                        "dt_updated_transactional": ""+signUpDate+""
                    }
                },
                "@force_optin": true,
                "marketing_optin": "EXPLICITLY_OPTEDIN",
                "@collection": "customers",
                "email": ""+$email+"",
                "phone_number": ""+$phone_number+"",
                "id": $customerID,
                "timestamp_subscribed": ""+signUpDate+""
            };
        }

        }

        // Let's disable the inputs for the duration of the Ajax request.
        // Note: we disable elements AFTER the form data has been serialized.
        // Disabled form elements will not be serialized.
        //$inputs.prop("disabled", true);

        $.ajax({
            type        : 'POST', // define the type of HTTP verb we want to use (POST for our form)
            url         : 'https://krw-om.herokuapp.com/krw-om-connect.php?customerID='+$customerID, // the url where we want to POST
            data        : JSON.stringify(ometriaData), // our data object
            dataType    : 'json', // what type of data do we expect back from the server
        })
            // using the done promise callback
            .done(function(response) {

                // log data to the console so we can see
                setTimeout(function() {
                    if (response.status === 'OK') {
                        if ($form.hasClass('ometria-email-form')) {
                            $form.find('.subscribe-form-email').blur();
                            $form.find('.subscribe-form-email').val('');
                            $form.find('.subscribe-form-email').attr('placeholder', 'Welcome to KREWE!');
                        } else {
                            $form.find('.subscribe-form-email').blur();
                            $form.find('.subscribe-form-email').attr('placeholder', 'THANK YOU!');
                            $form.find('.subscribe-form-subscribe').text("YOU'RE SUBSCRIBED").addClass('btn--subscribed');
                            $form.find('.subscribe-form-subscribe').css('pointer-events', 'none');
                            setTimeout(function(){
                                $('.subscribe-popup').fadeOut(400);
                                $('body').removeClass('subscribe-popup-open');
                            },2000);
                        }
                        

                        ometria.identify($email);
                        
                        
                    } else {
                        $form.find('.subscribe-form-email').blur();
                        $form.find('.subscribe-form-email').val('');
                        $form.find('.subscribe-form-email').attr('placeholder', 'INVALID EMAIL');
                    }

                    console.log(response);
                },0100);

                // here we will handle errors and validation messages
            });

        // stop the form from submitting the normal way and refreshing the page
        e.preventDefault();    

    });
});
